export const START_MARK = "LUX_start";
export const END_MARK = "LUX_end";
export const BOOLEAN_TRUE = "true";
